import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';

import styles from './commentBlockStyle';

class CommentBlock extends React.Component {
  state = {
    currentTabIndex: 0,
    currentTab: 'comment',
    opened: false,
    showValueInput: false,
    value: null
  };
  commentInput = null;

  handleChange = (event, value) => {
    this.setState({ currentTabIndex:value });
  };

  tabSelect = (tabName) => {
    const currentOpened = this.state.opened;
    const showValueInput = tabName === 'payment';
    this.setState({opened:true, currentTab: tabName, showValueInput}, () => {
      if (currentOpened) {
        this.commentInput.focus();
      }
    });
  };

  sendButtonClick = () => {
    if (this.state.showValueInput) {
      this.props.onSendComment(this.state.currentTab, this.commentInput.value, this.valueInput.value);
    } else {
      this.props.onSendComment(this.state.currentTab, this.commentInput.value);
    }

    this.setState({opened:false, currentTab: 'comment', currentTabIndex: 0, showValueInput: false});
  };

  render() {
    const { classes: c, onlyComment } = this.props;
    const tabClasses = { root: c.tabRoot, selected: c.tabSelected, labelContainer: c.labelContainer, label: c.label, wrapper: c.wrapper };
    return (
      <div className={c.root}>
        <Tabs
          value={this.state.currentTabIndex}
          onChange={this.handleChange}
          classes={{ root: c.tabsRoot, indicator: c.tabsIndicator }}
        >
          <Tab onClick={() => this.tabSelect('comment')} label="Комментарий" disableRipple classes={tabClasses} />
          {!onlyComment && <Tab onClick={() => this.tabSelect('treaty')} label="Договор" disableRipple classes={tabClasses}/>}
          {!onlyComment && <Tab onClick={() => this.tabSelect('payment')} label="Финансы" disableRipple classes={tabClasses}/>}
          {!onlyComment && <Tab onClick={() => this.tabSelect('visit')} label="Приход" disableRipple classes={tabClasses}/>}
          {!onlyComment && <Tab onClick={() => this.tabSelect('document')} label="Документы" disableRipple classes={tabClasses}/>}
        </Tabs>
        {!this.state.opened && <div onClick={() => this.tabSelect('comment')} style={{color:'#BABABA', fontSize:14, fontFamily:'Open Sans', fontWeight:200, padding:"9px 0px 2px 2px", cursor:'pointer'}}>Оставьте комментарий</div>}
        {this.state.opened && <TextField
          inputRef={input => {this.commentInput = input}}
          id="standard-multiline-static"
          autoFocus
          multiline
          rows="5"
          margin="normal"
          style={{ width: '100%', margin: 0 }}
          InputProps={{ spellCheck: false, classes: { underline: c.underline } }}
        />}
        {this.state.opened && <div className={c.buttonsFooter}>
          <Button onClick={this.sendButtonClick} variant="contained" color="primary" className={c.button}>отправить</Button>
          <Button onClick={()=>this.setState({opened:false, currentTabIndex: 0})} color="primary" className={c.button} style={{ marginLeft: 5, color: '#5B5B5B' }}>отмена</Button>
          {this.state.showValueInput &&
            <Input
              id="adornment-weight"
              inputRef={input => {this.valueInput = input}}
              type="number"
              inputProps={{ style:{ textAlign: 'right'}}}
              style={{width: '122px', marginLeft: '261px'}}
              endAdornment={<InputAdornment position="end">Руб.</InputAdornment>}
            />
          }
        </div>}
      </div>
    );
  }
}

CommentBlock.propTypes = {
  classes: PropTypes.object.isRequired,
  onSendComment: PropTypes.func
};

export default withStyles(styles)(CommentBlock);



// WEBPACK FOOTER //
// ./src/components/MaterialDashboardPro/Timeline/CommentBlock.js